import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getConsent, initGA, trackPageview } from '../utils/ga'

export const Analytics: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    if (getConsent() === 'granted') {
      initGA()
      trackPageview(location.pathname + location.search)
    }
    // Track on route change when already granted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search])

  return null
}
